// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var WeaveFeatureInterests;
(function (WeaveFeatureInterests) {
    WeaveFeatureInterests["UNSPECIFIED"] = "UNSPECIFIED";
    WeaveFeatureInterests["ATTRACT_NEW_CUSTOMERS"] = "ATTRACT_NEW_CUSTOMERS";
    WeaveFeatureInterests["ENGAGE_WITH_MY_CURRENT_CUSTOMERS"] = "ENGAGE_WITH_MY_CURRENT_CUSTOMERS";
    WeaveFeatureInterests["INCREASE_OFFICE_EFFICIENCY"] = "INCREASE_OFFICE_EFFICIENCY";
})(WeaveFeatureInterests || (WeaveFeatureInterests = {}));
export var WeaveFeatureInterests_index;
(function (WeaveFeatureInterests_index) {
    WeaveFeatureInterests_index[WeaveFeatureInterests_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    WeaveFeatureInterests_index[WeaveFeatureInterests_index["ATTRACT_NEW_CUSTOMERS"] = 1] = "ATTRACT_NEW_CUSTOMERS";
    WeaveFeatureInterests_index[WeaveFeatureInterests_index["ENGAGE_WITH_MY_CURRENT_CUSTOMERS"] = 2] = "ENGAGE_WITH_MY_CURRENT_CUSTOMERS";
    WeaveFeatureInterests_index[WeaveFeatureInterests_index["INCREASE_OFFICE_EFFICIENCY"] = 3] = "INCREASE_OFFICE_EFFICIENCY";
})(WeaveFeatureInterests_index || (WeaveFeatureInterests_index = {}));
